import { Routes } from '@angular/router';

export const COMPANIES_ROUTES: Routes = [
    {
        path: 'companies',
        title: 'Companies',
        data: {
            icon: 'apartment',
            module: 'COMPANY',
        },
        loadComponent: () => import('./companies.component').then((m) => m.CompaniesComponent),
        children: [
            {
                path: 'add',
                title: 'Add Company',
                loadComponent: () => import('./company-add/company-add.component').then((m) => m.CompanyAddComponent),
            },
            {
                path: ':id',
                title: 'Company View',
                loadComponent: () => import('./company-view/company-view.component').then((m) => m.CompanyViewComponent),
            },
            {
                path: ':id/edit',
                title: 'Edit Company',
                loadComponent: () => import('./company-edit/company-edit.component').then((m) => m.CompanyEditComponent),
            },
            {
                path: ':companyId/add-user',
                title: 'Add User',
                loadComponent: () => import('../users/user-add/user-add.component').then((m) => m.UserAddComponent),
            },
            {
                path: ':id/budgets',
                title: 'Add Budgets',
                loadComponent: () => import('./company-budget/company-budget.component').then((m) => m.CompanyBudgetComponent)
            },
            {
                path: ':id/budgets/upload-budgets',
                title: 'Upload Budgets',
                loadComponent: () => import('./company-upload-budgets/company-upload-budgets.component').then((m) => m.CompanyUploadBudgetsComponent)
            },            
            {
                path: ':companyId/users/:userId',
                title: 'View User',
                loadComponent: () => import('../users/user-view/user-view.component').then((m) => m.UserViewComponent),
            },
            {
                path: '',
                pathMatch: 'full',
                data: {
                   reuse: true,
                },                
                loadComponent: () => import('./company-list/company-list.component').then((m) => m.CompanyListComponent),
            },
        ]
    },
];